import { createElement as h } from "react"

import { CircularProgress } from "@mui/material"
import { makeStyles } from "@mui/styles"
import { mergeRight } from "ramda"

const useDynamicStyles = makeStyles(({ withPalette }) => ({
  root: ({ color, shade }) => ({
    color: withPalette(color, shade),
  }),
}))

export const Circular = ({ color, shade, size = 24, ...props }) =>
  h(
    CircularProgress,
    mergeRight(props, {
      classes: useDynamicStyles({ color, shade }),
      color: "inherit",
      size,
    }),
  )
